import React, { useState, useContext } from "react";
import { ALL_ITEM_CATEGORIES_QUERY } from "../../../graphql/ItemCategories/ItemCategories.graphql";

import {
  AddItemCategoryForm,
  EditItemCategoryForm
} from "../../../components/ItemCategories";

import { ModalContext } from "../../../components/ModalProvider";

import DataTable from "../../../components/DataTable";
import { ITEM_CATEGORY_COLUMNS } from "./columns";

import PageHeader from "../../../components/PageHeader";

import ItemCategoryFilters from "./ItemCategoryFilters";
import { getFilterState, saveFilterState } from "../../../utils";

const ItemCategoriesPage = () => {
  const INITIAL_FILTER_STATE = getFilterState("ITEM_CATEGORY_FILTERS", {
    Active: true
  });
  const { setModalOpen } = useContext(ModalContext);

  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const handleSetFilters = inputs => {
    saveFilterState("ITEM_CATEGORY_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({ Active: true });

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={ItemCategoryFilters}
        columns={ITEM_CATEGORY_COLUMNS}
        filters={filters}
        name="ItemCategorys"
        query={ALL_ITEM_CATEGORIES_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Item Categories"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddItemCategoryForm onComplete={() => setModalOpen(false, "")} />
          )
        }
      />
      {/* TODO */}
      <DataTable
        columns={ITEM_CATEGORY_COLUMNS}
        dataQuery={ALL_ITEM_CATEGORIES_QUERY}
        initialSortBy={[{ id: "Description", desc: false }]}
        name="ItemCategory"
        where={{ ...filters }}
        onRowClick={data => {
          setModalOpen(
            true,
            <EditItemCategoryForm
              itemCategory={data}
              onComplete={() => setModalOpen(false, "")}
            />
          );
        }}
      />
    </React.Fragment>
  );
};

ItemCategoriesPage.propTypes = {};
export default ItemCategoriesPage;
